import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from "@angular/core";

import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { CoreMenuService } from "@core/components/core-menu/core-menu.service";

@Component({
  selector: "[core-menu]",
  templateUrl: "./core-menu.component.html",
  styleUrls: ["./core-menu.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoreMenuComponent implements OnInit {
  currentUser: any;

  @Input() layout = "vertical";

  @Input() menu: any;

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   *
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {CoreMenuService} _coreMenuService
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreMenuService: CoreMenuService,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Set the menu either from the input or from the service
    this.menu = this.menu || this._coreMenuService.getCurrentMenu();

    // Subscribe to the current menu changes
    this._coreMenuService.onMenuChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
      this.currentUser = this._coreMenuService.currentUser;

      // Load menu
      this.menu = this._coreMenuService.getCurrentMenu();

      this.menu = this.menu
        .map((result: any) => {
          if (Object.keys(result).length < 1) {
            return null;
          }

          if (result.parent_id) {
            const parent: any = this.menu.find((item: any) => item.id === result.parent_id);
            delete result.icon;

            const alreadyExists: any = (parent.children || []).find((item: any) => item.id === result.id);

            if (!alreadyExists) {
              if (parent.children) {
                parent.children.push(result);
              } else {
                parent.children = [result];
              }
              parent.children = parent.children.sort((a: any, b: any) => (a.order > b.order ? 1 : -1));
            }
            return null;
          }

          return result;
        })
        .filter((el: any) => el);

      this._changeDetectorRef.markForCheck();
    });
    //Nel caso di collaboratore escludiamo la voce archivio rapportini usando l'ID
    if (this.currentUser.role === "Collaboratore") {
      const reportIndex = this.menu.findIndex((object: any) => {
        return object.id === "workday-user-report";
      });
      this.menu[reportIndex].children = this.menu[reportIndex].children.filter((child: any) => child.id !== "my-workday-user-report");
    }
  }

  hasCapability(item: any) {
    if ((!item.capability && item.type !== "collapsible") || item.capability.length < 1) return true;
    return this.currentUser.capabilities.includes(item.capability);
  }
}
